import { ReactNode } from 'react'
import * as styles from 'styles/atoms/Text.css'
import * as cn from 'classnames'
import { QAMarked } from 'interfaces/component'

type TextProps = QAMarked & {
  text?: string
  children?: ReactNode
  className?: string
}

const PAGE_HEADING_QA_MARKER = 'page-heading'

export const ExternalPageHeading = ({ children }: TextProps) => (
  <h1 className={ styles.externalPageHeading } data-qa-marker={ PAGE_HEADING_QA_MARKER }>
    { children }
  </h1>
)

export const PageHeading = ({ children, text, className, qaMarker }: TextProps) => (
  <h1 className={ cn(styles.pageHeading, className) } data-qa-marker={ qaMarker ? qaMarker : PAGE_HEADING_QA_MARKER }>
    { children || text }
  </h1>
)

export const ModuleTitle = ({ children, text, className }: TextProps) => (
  <h2 className={ cn(styles.moduleTitle, className) }>{ children || text }</h2>
)

export const SmallHeading = ({ children, text, className }: TextProps) => (
  <h4 className={ cn(styles.smallHeading, className) }>
    { children || text }
  </h4>
)

export const ModuleSubtitle = ({ children, text, className }: TextProps) => (
  <span className={ cn(styles.moduleSubtitle, className) }>{ children || text }</span>
)

export const BodyText = ({ children, text, className }: TextProps) => (
  <p className={ cn(styles.bodyText, className) }>{ children || text }</p>
)

export const HomepageText = ({ children, text, className }: TextProps) => (
  <p className={ cn(styles.homepageText, className) }>{ children || text }</p>
)

export const Caption = ({ children, text, className }: TextProps) => (
  <div className={ cn(styles.captionText, className) }>{ children || text }</div>
)

export const PopupTitle = ({ children, className }: TextProps) => (
  <div className={ cn(styles.popupTitle, className) }>{ children }</div>
)
